import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    filters: [],
    searchMeta: null,
};

const getters = {
    filters(state) {
        return state.filters;
    },
};

const mutations = {
    setFilters(state, filters) {
        state.filters = filters;
    },

    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }) {
        startLoading(dispatch, 'get-fuel-sales-by-tank-meta');

        return axios
            .get(Laroute.route('franchise.report.fuel.tank_sales.meta'))
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-fuel-sales-by-tank-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-fuel-sales-by-tank-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
